import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  perfiles: [],
  totalCount: 0,
  loading: false,
}

export const Slice = createSlice({
  name: 'perfiles',
  initialState,
  reducers: {
    setPerfiles: (state, action) => {
      state.perfiles = action.payload
    },
    setTotalCount: (state, action) => {
      state.totalCount = action.payload
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
  },
})

export const { setPerfiles, setTotalCount, setLoading } = Slice.actions
export default Slice.reducer
